<template>
  <div class="app-container">
    <div class="chartType" style="margin: 20px 0;">
      <div style="display: inline-block;margin-bottom: 10px;">
        {{ $t('mdfeTranslate.YearAndMonth') }}：
        <el-date-picker
          v-model="month"
          type="month"
          :placeholder="$t('collectionCenter.pleaseChoose')"
          value-format="yyyy-MM"
          :picker-options="pickerOptions"
          @change="getChartData"
        />
      </div>
      <el-radio-group v-model="type" @change="initChart()">
        <el-radio-button :label="2">{{ $t('customerManagements.allData') }}</el-radio-button><!--全部数据-->
        <el-radio-button :label="1">{{ $t('mdfeTranslate.OnlyCollect') }}</el-radio-button><!--仅揽收-->
        <el-radio-button :label="0">{{ $t('mdfeTranslate.OnlySend') }}</el-radio-button><!--仅派送-->
        <el-radio-button :label="3">{{ $t('mdfeTranslate.OnlyTotal') }}</el-radio-button><!--仅总数-->
      </el-radio-group>
    </div>
    <el-card>
      <div id="chart" style="width: 100%;height: 400px;" />
    </el-card>
    <div style="display: flex;padding: 20px calc(4% + 20px)">
      <div
        v-for="(item, index) in groupedDayCounts"
        :key="index"
        :style="{width: (item.length / dayCounts.length) * 100 + '%'}"
        class="weekItem"
      >
        <span v-if="index === 0">{{ $t('mdfeTranslate.FirstWeek') }}</span>
        <span v-if="index === 1">{{ $t('mdfeTranslate.SecondWeek') }}</span>
        <span v-if="index === 2">{{ $t('mdfeTranslate.ThirdWeek') }}</span>
        <span v-if="index === 3">{{ $t('mdfeTranslate.FourthWeek') }}</span>
        <span v-if="index === 4">{{ $t('mdfeTranslate.FifthWeek') }}</span>
      </div>
    </div>
    <div style="display: flex;justify-content: center">
      <div class="numTypeItem">
        <span class="numItem" style="background: #eb6f62;" />{{ $t('newOrder.collectionQuantity') }} <!--揽收数量-->
      </div>
      <div class="numTypeItem">
        <span class="numItem" style="background: #5cace1;" />{{ $t('mdfeTranslate.TotalNumberDeliveries') }} <!--派送数量-->
      </div>
      <div class="numTypeItem">
        <span class="numItem" style="background: #57d58c;" />{{ $t('trajectory.total') }} <!--总数-->
      </div>
    </div>
    <div style="display: flex">
      <el-card v-for="(item, index) in totalItem" :key="index" style="flex: 1;text-align: center;margin: 10px">
        <div style="font-weight: bold;color: #6c757d;">{{ item.name }}</div>
        <div style="font-size: 26px;font-weight: bold;color: #2c3e50;margin: 10px 0">{{ formatNumber(item.num, 0) }}</div>
        <div style="font-size: 14px;color: #adb5bd;">{{ item.day }}</div>
      </el-card>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { getCteInvoiceTrend } from '@/api/invoiceCenter';
import { formatNumber } from '@/utils/tools';
const date = new Date();
const monthDay = (date.getMonth() + 1) + '-' + date.getDate();
export default {
  name: 'InvoiceCenterEtc',
  data() {
    return {
      month: '',
      type: 2,
      myChart: null,
      dayCounts: [],
      groupedDayCounts: [],
      totalItem: {
        pickup: { name: this.$t('mdfeTranslate.HighestCollectionAmount'), day: monthDay, num: 0 }, // 最高揽收量
        delivery: { name: this.$t('mdfeTranslate.HighestDeliveryAmount'), day: monthDay, num: 0 }, // 最高派送量
        total: { name: this.$t('mdfeTranslate.HighestTotal'), day: monthDay, num: 0 }, // 最高总量
        average: { name: this.$t('mdfeTranslate.AverageDailyTotal'), day: monthDay, num: 0 } // 平均每日总量
      },
      pickerOptions: {
        disabledDate(time) {
          // 禁用当前月之后的月份
          return time.getTime() > Date.now();
        }
      },
      formatNumber
    };
  },
  mounted() {
    // 获取当前月份
    const now = new Date();
    this.month = now.getFullYear() + '-' + (now.getMonth() + 1);
    this.myChart = echarts.init(document.getElementById('chart'));
    this.getChartData();
    // 添加屏幕缩放自适应
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除监听器，防止内存泄漏
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 图表自适应
    handleResize() {
      // 调用 ECharts 的 resize 方法实现自适应
      if (this.myChart) {
        this.myChart.resize();
      }
    },
    // 获取数据
    getChartData() {
      getCteInvoiceTrend(this.month).then(res => {
        if (res.code === 200) {
          if (res.data !== null && res.data !== undefined && res.data !== '') {
            // 按日期day属性从小到大排序
            res.data.dayCounts.sort((a, b) => {
              return new Date(a.day) - new Date(b.day);
            });
            this.dayCounts = res.data.dayCounts;
            // 将 dayCounts 按7个一组分组
            this.groupedDayCounts = this.dayCounts.reduce((result, item, index) => {
              const groupIndex = Math.floor(index / 7);
              if (!result[groupIndex]) {
                result[groupIndex] = [];
              }
              result[groupIndex].push(item);
              return result;
            }, []);
            // 最高揽收量
            this.totalItem.pickup.day = this.dateFormat(res.data.maxCollectionCount.day);
            this.totalItem.pickup.num = res.data.maxCollectionCount.collectionCount;
            // 最高派送量
            this.totalItem.delivery.day = this.dateFormat(res.data.maxDeliveryCount.day);
            this.totalItem.delivery.num = res.data.maxDeliveryCount.deliveryCount;
            // 最高总量
            this.totalItem.total.day = this.dateFormat(res.data.maxTotalCount.day);
            this.totalItem.total.num = res.data.maxTotalCount.totalCount;
            // 平均每日总量
            this.totalItem.average.day = this.dayCounts.length + ' ' + this.$t('mdfeTranslate.dayAverage');
            this.totalItem.average.num = res.data.avgCount;
          } else {
            this.$message.error(this.$t('collectionCenter.nullMsg'));
            this.dayCounts = [];
            this.groupedDayCounts = [];
            this.totalItem.pickup.day = null;
            this.totalItem.pickup.num = 0;
            this.totalItem.delivery.day = null;
            this.totalItem.delivery.num = 0;
            this.totalItem.total.day = null;
            this.totalItem.total.num = 0;
            this.totalItem.average.day = null;
            this.totalItem.average.num = 0;
          }
          this.initChart();
        }
      });
    },
    dateFormat(date) {
      const datePart = date.split(' ')[0]; // 提取日期部分 '2025-08-02'
      const [year, month, day] = datePart.split('-'); // 分割得到年、月、日
      console.log(year);
      return `${month}-${day}`;
    },
    initChart() {
      const collectionCounts = {
        name: this.$t('newOrder.collectionQuantity'), // '揽收数量',
        type: 'line',
        smooth: true,
        itemStyle: { color: '#eb6f62' },
        lineStyle: { color: '#eb6f62' },
        data: []
      };
      const deliveryCounts = {
        name: this.$t('mdfeTranslate.TotalNumberDeliveries'), // '派送数量',
        type: 'line',
        smooth: true,
        itemStyle: { color: '#5cace1' },
        lineStyle: { color: '#5cace1' },
        data: []
      };
      const totalCounts = {
        name: this.$t('trajectory.total'), // '总数',
        type: 'line',
        smooth: true,
        itemStyle: { color: '#57d58c' },
        lineStyle: { color: '#57d58c' },
        data: []
      };
      const dataArr = [];
      if (this.type === 0) {
        dataArr.push(deliveryCounts);
      }
      if (this.type === 1) {
        dataArr.push(collectionCounts);
      }
      if (this.type === 2) {
        dataArr.push(collectionCounts);
        dataArr.push(deliveryCounts);
        dataArr.push(totalCounts);
      }
      if (this.type === 3) {
        dataArr.push(totalCounts);
      }
      const days = [];
      this.dayCounts.map(item => {
        days.push(this.dateFormat(item.day));
        collectionCounts.data.push(item.collectionCount / 1000);
        deliveryCounts.data.push(item.deliveryCount / 1000);
        totalCounts.data.push(item.totalCount / 1000);
      });
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            console.log(params, '===params===');
            // params 是一个数组，包含当前鼠标悬停的所有系列数据
            let tooltipHtml = `<div>${params[0].name}</div>`;
            params.forEach(param => {
              tooltipHtml += `<div><span style="padding: 6px;background: ${param.color};display: inline-block;border-radius: 5px;margin-right: 5px"></span>${param.seriesName}：${(param.value * 1000).toFixed(0)}</div>`;
            });
            return tooltipHtml;
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false // 隐藏分隔线
          },
          axisLabel: {
            rotate: 45, // x轴标签倾斜45度
            interval: 0 // 强制显示所有刻度
          },
          data: days
        },
        yAxis: {
          type: 'value',
          splitLine: { // 设置Y轴的线条的颜色;
            lineStyle: {
              type: 'dashed',
              color: ['#EDEEF1']
            }
          },
          axisLabel: {
            formatter: (value) => {
              return value !== 0 ? value + 'K' : value; // 在每个刻度值后添加单位
            }
          }
        },
        series: dataArr
      };
      option && this.myChart.setOption(option, true);
    }
  }
};
</script>

<style>
.searchForm .el-form-item {
  margin-bottom: 0;
}
.chartType .el-radio-button {
  margin: 0 10px;
  border: 1px solid #DCDFE6;
  border-radius: 50px;
  overflow: hidden;
  color: #000;
}
.chartType .el-radio-button__inner {
  background: #f1f5f9;
  border: none;
}
.chartType .el-radio-button.is-active {
  border-color: #409EFF;
}
.weekItem {
  border-top: 2px solid #e9ecef;
  text-align: center;
  font-size: 14px;
  padding-top: 5px;
}
.numItem {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  margin-right: 5px;
}
.numTypeItem {
  padding: 10px 20px;
  border-radius: 20px;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin: 10px 15px;
}
</style>
